module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-4": ""
    }
  }, [_c('v-btn-toggle', {
    staticClass: "form-button",
    model: {
      value: (_vm.channel),
      callback: function($$v) {
        _vm.channel = $$v
      },
      expression: "channel"
    }
  }, _vm._l((_vm.channels), function(channelType) {
    return _c('v-btn', {
      key: channelType.id,
      class: {
        'btn--active': _vm.channel === channelType.id
      },
      attrs: {
        "flat": "",
        "disabled": _vm.channel === channelType.id,
        "value": channelType.id
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(channelType.name) + "\n\t\t\t\t")])
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-chip', {
    staticClass: "white--text"
  }, [_vm._v("Cliente Vip")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de creación")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuCreation),
      callback: function($$v) {
        _vm.menuCreation = $$v
      },
      expression: "menuCreation"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de creación",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateCreation),
      callback: function($$v) {
        _vm.dateCreation = $$v
      },
      expression: "dateCreation"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateCreation),
      callback: function($$v) {
        _vm.dateCreation = $$v
      },
      expression: "dateCreation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de ingreso")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnter),
      callback: function($$v) {
        _vm.menuEnter = $$v
      },
      expression: "menuEnter"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de ingreso",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnter),
      callback: function($$v) {
        _vm.dateEnter = $$v
      },
      expression: "dateEnter"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.validDate
    },
    model: {
      value: (_vm.dateEnter),
      callback: function($$v) {
        _vm.dateEnter = $$v
      },
      expression: "dateEnter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Fecha de salida")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker menu-form",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuOut),
      callback: function($$v) {
        _vm.menuOut = $$v
      },
      expression: "menuOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de salida",
      "append-icon": "event",
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateOut),
      callback: function($$v) {
        _vm.dateOut = $$v
      },
      expression: "dateOut"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "allowed-dates": _vm.allowedDatesOut,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateOut),
      callback: function($$v) {
        _vm.dateOut = $$v
      },
      expression: "dateOut"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Cantidad de noches")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.bookingQuantityNights),
      callback: function($$v) {
        _vm.bookingQuantityNights = $$v
      },
      expression: "bookingQuantityNights"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Completa los datos")])]), _vm._v(" "), _vm._l((_vm.guests), function(model, indexModel) {
    return _c('v-flex', {
      key: indexModel,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.guests.length > 1),
        expression: "guests.length > 1"
      }],
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n\t\t\t\t\tPersona " + _vm._s(indexModel + 1) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de Habitación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.roomsType,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "label": "Standart",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.roomType),
        callback: function($$v) {
          model.roomType = $$v
        },
        expression: "model.roomType"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Habitación")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "101"
      },
      model: {
        value: (model.room),
        callback: function($$v) {
          model.room = $$v
        },
        expression: "model.room"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nombres")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (model.name),
        callback: function($$v) {
          model.name = $$v
        },
        expression: "model.name"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (model.lastname),
        callback: function($$v) {
          model.lastname = $$v
        },
        expression: "model.lastname"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIcon
      },
      model: {
        value: (model.menuBirthDate),
        callback: function($$v) {
          model.menuBirthDate = $$v
        },
        expression: "model.menuBirthDate"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha de nacimiento",
        "append-icon": _vm.arrowIconBirth,
        "append-icon-cb": _vm.toggleIconBirthDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (model.birthDate),
        callback: function($$v) {
          model.birthDate = $$v
        },
        expression: "model.birthDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "locale": "es-PE",
        "date-format": _vm.changeFormatDate,
        "formatted-value": _vm.formatted,
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (model.birthDate),
        callback: function($$v) {
          model.birthDate = $$v
        },
        expression: "model.birthDate"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "autocomplete": "",
        "items": _vm.countries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.country),
        callback: function($$v) {
          model.country = $$v
        },
        expression: "model.country"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.genders,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.gender),
        callback: function($$v) {
          model.gender = $$v
        },
        expression: "model.gender"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.civilStatus,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.civilState),
        callback: function($$v) {
          model.civilState = $$v
        },
        expression: "model.civilState"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "nombre@mail.com"
      },
      model: {
        value: (model.email),
        callback: function($$v) {
          model.email = $$v
        },
        expression: "model.email"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "value",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.typeDocument),
        callback: function($$v) {
          model.typeDocument = $$v
        },
        expression: "model.typeDocument"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "number"
      },
      model: {
        value: (model.document),
        callback: function($$v) {
          model.document = $$v
        },
        expression: "model.document"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Niños")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "placeholder": "0"
      },
      model: {
        value: (model.children),
        callback: function($$v) {
          model.children = $$v
        },
        expression: "model.children"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Bebés")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "placeholder": "0"
      },
      model: {
        value: (model.babys),
        callback: function($$v) {
          model.babys = $$v
        },
        expression: "model.babys"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.phone),
        callback: function($$v) {
          model.phone = $$v
        },
        expression: "model.phone"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Tarjeta Vip")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.vipCard),
        callback: function($$v) {
          model.vipCard = $$v
        },
        expression: "model.vipCard"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "text-xs-left": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.channel === 2),
        expression: "channel === 2"
      }],
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Operador")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.operator),
        callback: function($$v) {
          model.operator = $$v
        },
        expression: "model.operator"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Vendedor")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      model: {
        value: (model.seller),
        callback: function($$v) {
          model.seller = $$v
        },
        expression: "model.seller"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Modo de captura")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.media,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (model.mediaSelected),
        callback: function($$v) {
          model.mediaSelected = $$v
        },
        expression: "model.mediaSelected"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('button-create', {
    staticClass: "justify-center",
    attrs: {
      "btn-function": "",
      "text": "Agregar a otra persona"
    },
    on: {
      "function-click": _vm.addGuest
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "label": _vm.dataModel[_vm.channel].title,
      "color": "success",
      "hide-details": ""
    },
    model: {
      value: (_vm.dataModel[_vm.channel].active),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].active = $$v
      },
      expression: "dataModel[channel].active"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    class: {
      'disabled-block': !_vm.dataModel[_vm.channel].active
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombres")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nombres",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].name),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].name = $$v
      },
      expression: "dataModel[channel].name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Apellidos",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].lastname),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].lastname = $$v
      },
      expression: "dataModel[channel].lastname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 2),
      expression: "channel === 2"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº Registro Fiscal")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de RUC, RUT, IVA, VAT",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].documentNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].documentNumber = $$v
      },
      expression: "dataModel[channel].documentNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 3),
      expression: "channel === 3"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de file")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Voucher",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].fileNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].fileNumber = $$v
      },
      expression: "dataModel[channel].fileNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 4),
      expression: "channel === 4"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Voucher")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Voucher",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].voucher),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].voucher = $$v
      },
      expression: "dataModel[channel].voucher"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === 5),
      expression: "channel === 5"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Reserva")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Nº de Reserva",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].bookingNumber),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].bookingNumber = $$v
      },
      expression: "dataModel[channel].bookingNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "nombre@mail.com",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].email),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].email = $$v
      },
      expression: "dataModel[channel].email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-prefix",
    attrs: {
      "type": "number",
      "prefix": "+51",
      "disabled": !_vm.dataModel[_vm.channel].active
    },
    model: {
      value: (_vm.dataModel[_vm.channel].phone),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].phone = $$v
      },
      expression: "dataModel[channel].phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-main",
    attrs: {
      "autocomplete": "",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "disabled": !_vm.dataModel[_vm.channel].active,
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dataModel[_vm.channel].country),
      callback: function($$v) {
        _vm.dataModel[_vm.channel].country = $$v
      },
      expression: "dataModel[channel].country"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider-form"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.additionals), function(additional) {
    return _c('v-flex', {
      key: additional.id,
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox",
      attrs: {
        "label": additional.name
      },
      model: {
        value: (_vm.selectedAdditionals),
        callback: function($$v) {
          _vm.selectedAdditionals = $$v
        },
        expression: "selectedAdditionals"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": "",
        "value": _vm._f("round")(additional.price)
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Total")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-regular",
    attrs: {
      "type": "text",
      "readonly": "",
      "hide-details": "",
      "prefix": "$",
      "value": _vm._f("round")(_vm.totalAmount)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Observaciones")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-textarea mt-1",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 3,
      "textarea": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form mt-3",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04efa2f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/checkin/Form.vue
// module id = 1574
// module chunks = 74